import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-coins" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "p-ml-2"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Prezzi e Costi ")
const _hoisted_4 = {
  key: 0,
  class: "p-success"
}
const _hoisted_5 = {
  key: 1,
  class: "p-ml-2"
}
const _hoisted_6 = {
  key: 2,
  class: "p-ml-2"
}
const _hoisted_7 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_8 = { class: "p-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Prezzo stimato:", -1)
const _hoisted_10 = { class: "p-col" }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Costo stimato:", -1)
const _hoisted_13 = { class: "p-col" }
const _hoisted_14 = { class: "p-grid" }
const _hoisted_15 = {
  key: 0,
  class: "p-col"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("header", { class: "p-mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Prezzo extra:")
], -1)
const _hoisted_17 = {
  key: 1,
  class: "p-col"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("header", { class: "p-mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Costo extra:")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _hoisted_1,
      (_ctx.isTMT)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _hoisted_3,
            (_ctx.isPaid)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(Pagato)"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCustomer)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Prezzi"))
        : _createCommentVNode("", true),
      (_ctx.isSupplier)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Costi"))
        : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      (!_ctx.isSupplier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              (_ctx.isTMT)
                ? (_openBlock(), _createBlock(_component_InfoIcon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("small", null, [
                        _createElementVNode("pre", null, _toDisplayString(_ctx.logPrice), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.order.est_price) + " €", 1),
            (!_ctx.isCustomer)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_11, [
                    _hoisted_12,
                    (_ctx.isTMT)
                      ? (_openBlock(), _createBlock(_component_InfoIcon, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("small", null, [
                              _createElementVNode("pre", null, _toDisplayString(_ctx.logCost), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.order.est_cost) + " €", 1)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.isTMT || (_ctx.isCustomer && _ctx.order.est_price_extra1_value))
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_FloatLabel, {
                label: "Descrizione prezzo extra",
                class: "p-field"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.order.est_price_extra1_desc,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.order.est_price_extra1_desc = $event)),
                    disabled: _ctx.isReadonly
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_FloatLabel, {
                label: "Prezzo extra",
                class: "p-field"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.order.est_price_extra1_value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.order.est_price_extra1_value = $event)),
                    mode: "currency",
                    currency: "EUR",
                    disabled: _ctx.isReadonly
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTMT || (_ctx.isSupplier && _ctx.order.est_cost_extra1_value > 0))
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_FloatLabel, {
                label: "Descrizione costo extra",
                class: "p-field"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.order.est_cost_extra1_desc,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.order.est_cost_extra1_desc = $event)),
                    disabled: _ctx.costExtraReadonly
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_FloatLabel, {
                label: "Costo extra",
                class: "p-field"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.order.est_cost_extra1_value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.order.est_cost_extra1_value = $event)),
                    mode: "currency",
                    currency: "EUR",
                    disabled: _ctx.costExtraReadonly
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}